// extracted by mini-css-extract-plugin
export default {"Button":"PCButton_Button__4J32X","ButtonSmaller":"PCButton_ButtonSmaller__Lkgrw","ButtonSmall":"PCButton_ButtonSmall__d1unH"};